document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 767) {
    var checkoutForm = document.querySelector('product-info checkout-form');
    var mainElement = document.querySelector('main');

    if (checkoutForm && mainElement) {
      checkoutForm.classList.add('custom-checkout-form-mobile');
      mainElement.appendChild(checkoutForm);

      var footer = document.querySelector('.footer-bottom');

      if (footer) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              checkoutForm.classList.add('footer-in-view');
            } else {
              checkoutForm.classList.remove('footer-in-view');
            }
          });
        }, {
          root: null,
          threshold: 0.1
        });

        observer.observe(footer);
      }
    }
  }
});
